import * as React from 'react';
import { observable, action } from 'mobx';
import AlertModal from '../components/modals/AlertModal';

class ModalManager {
  @observable
  activeModal?: React.ReactNode;

  @action
  showModal(modal: React.ReactNode) {
    this.activeModal = modal;
  }

  @action
  showAlertModal(header?: string, message?: string) {
    this.activeModal = <AlertModal header={header} message={message} />;
  }

  @action
  closeModal() {
    this.activeModal = undefined;
  }
}

const instance = new ModalManager();

export { instance as ModalManager };
